import { DeviceTypeType } from '../types/app_data';
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage?: (msg: string) => void;
    };
  }
}

export type RNMessage = 'finished';

/**
 * Determines if the device is a mobile device based on the user agent string.
 *
 * @param userAgent
 */
export const isMobile = (userAgent?: string): boolean => {
  if (!userAgent) return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
};

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', undefined.
 */
export const getMobileOperatingSystem = (userAgent: string): DeviceTypeType | undefined => {
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return undefined;
  }

  if (/android/i.test(userAgent)) {
    return DeviceTypeType.Android;
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return DeviceTypeType.Ios;
  }

  return undefined;
};

/**
 * Post a message to weview, which is monitored by our mobile app.
 */
export const postRNWebViewMessage = (message: RNMessage): void => {
  if (typeof window !== 'undefined' && window.ReactNativeWebView?.postMessage) {
    let payload: Record<string, string | boolean> | null = null;
    switch (message) {
      case 'finished':
        payload = { finished: true };
        break;
      default:
        console.warn('Unknown message:', message);
        break;
    }

    if (payload) {
      window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    }
  }
};
